import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu";
import { IncludeCustomPropertyType } from "common/query-builder/query-block/properties-menu/types";
export function template() {
  const position = this.attr(`position`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-context-menu-wrapper"
  }, this.attr(`open`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-context-menu",
    style: {
      position: `absolute`,
      left: `${position.left}px`,
      top: `${position.top}px`
    },
    hook: { insert: this.helpers.inserted }
  }, /* @__PURE__ */ jsx("style", null, this.helpers.getCss()), /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open: this.attr(`open`),
      "experimental-positioning": true
    },
    on: {
      change: this.helpers.handleDropMenuChange,
      click: (ev) => ev.stopPropagation()
    },
    props: {
      positionParent: this.state.positionParent
    }
  }, this.state.secondaryAction === `breakdown` ? /* @__PURE__ */ jsx(PropertiesMenuEl, {
    attrs: {
      "disabled-items": this.helpers.breakdownDisabledItemsMap(),
      "event-names": [this.attr(`breakdown-event`)],
      open: this.attr(`open`),
      "project-id": this.attr(`project-id`),
      "workspace-id": this.attr(`workspace-id`),
      "include-custom-properties": IncludeCustomPropertyType.All,
      "description-edit-disabled": true
    },
    on: {
      select: this.helpers.handleBreakdownMenuSelect
    }
  }) : /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".context-menu-options",
    attrs: { sections: [{ items: this.helpers.menuItems() }] },
    on: {
      click: (ev) => ev.stopPropagation(),
      clickItem: this.helpers.handleContextMenuSelect
    },
    props: {
      keydownProxyEl: document.body
    }
  }))) : null);
}
